 import axios from 'axios';
 import { getToken as getAuthToken } from 'api/auth';



const API_BASE_RAW = import.meta.env.VITE_API_BASE || '/api';
const API_BASE = API_BASE_RAW.replace(/\/$/, '');
const IS_ABS = /^https?:\/\//.test(API_BASE);

 export const axiosServices = axios.create({
   baseURL: API_BASE
 });

// Subscriptions needs to keep "/api" in the path.
// dev: base="/api"     -> /api + /subscriptions/  
// prod: base="http://62.72.59.128:8005" -> add "/api" -> http://...:8005/api + /subscriptions/ 
export const axiosSubs = axios.create({
  baseURL: IS_ABS ? `${API_BASE}/api` : '/api'
});
[axiosServices, axiosSubs].forEach((inst) => {
  inst.interceptors.request.use((config) => {
    const BASENAME = (import.meta.env.VITE_APP_BASE_NAME || '/').replace(/\/+$/, '');
    const ADMIN_PREFIX = `${BASENAME || ''}/admin`;
    const path = window.location.pathname.replace(/\/+$/, '');
    const isAdmin = path === ADMIN_PREFIX || path.startsWith(`${ADMIN_PREFIX}/`);

    const token = getAuthToken({ admin: isAdmin });
    console.log('[axios] path=', path, 'isAdmin=', isAdmin, 'sending auth?', !!token);

    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  inst.interceptors.response.use(
    (response) => response,
    (error) => {
      let message =
        error.response?.data?.error ||
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "An unknown error occurred";

      //  ensure we don’t lose original props
      error.customMessage = message;
      return Promise.reject(error);
    }
  );
});



 // SWR fetcher (general)
 export const fetcher = (path) =>
   axiosServices.get(path.startsWith('/') ? path : `/${path}`).then((r) => r.data);

 export default axiosServices;
